import { initMobileAccordion } from "./mobile-accordion";
import { cleanupMobileModifications } from "./cleanup";
import { closeMobileMenu } from "./utils";

export const setupResponsiveHandler = (
  navList: HTMLElement | null,
  burgerMenu: HTMLElement | null,
  fullPageOverlayControl: HTMLButtonElement | null,
) => {
  const handleResize = () => {
    // Always close the mobile menu on resize
    closeMobileMenu(navList, burgerMenu, fullPageOverlayControl);

    if (window.matchMedia("(max-width: 1239px)").matches) {
      // Mobile view
      cleanupMobileModifications(navList);
      initMobileAccordion(navList);
    } else {
      // Desktop view - clean up mobile modifications
      cleanupMobileModifications(navList);
    }
  };

  // Run on initial load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", handleResize);
  } else {
    setTimeout(handleResize, 100);
  }

  // Debounced resize handler
  let resizeTimer: ReturnType<typeof setTimeout>;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(handleResize, 250);
  });
};

